import fetchServer from "../fetchServer";

function normalizeEsimBookingItem(item) {
  if (!item || typeof item !== "object") return null;

  if (item.esimBooking || item.esim_booking) {
    const esimBooking = item.esimBooking || item.esim_booking;
    const booking = item.booking || item.mainBooking || {};
    return {
      ...esimBooking,
      mainBooking: booking,
      bookingId: booking?.bookingId || esimBooking?.bookingId,
    };
  }

  return {
    ...item,
    bookingId: item.bookingId || item.mainBooking?.bookingId,
  };
}

export default async function getEsimBookings(
  { limit = 10, offset = 0, populate },
  setLoading,
) {
  let result = {
    return: 0,
    msg: "Something went wrong fetching eSIM bookings!",
    data: null,
  };
  setLoading?.(true);

  try {
    const params = new URLSearchParams({
      limit: String(limit),
      offset: String(offset),
      skip: String(offset),
    });
    if (populate) params.set("populate", populate);

    const res = await fetchServer({
      method: "GET",
      url: `/product/v1/esim/booking?${params.toString()}`,
    });
    const apiMessage = res?.data?.message;
    if (res?.data && !res?.data?.error) {
      const payload = res?.data?.data;
      const rawItems = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.data)
          ? payload.data
          : Array.isArray(res?.data?.data?.data)
            ? res.data.data.data
            : [];
      const items = rawItems.map(normalizeEsimBookingItem).filter(Boolean);
      const total =
        payload?.meta?.total ??
        res?.data?.meta?.total ??
        res?.data?.data?.meta?.total ??
        items.length;

      result = {
        return: 1,
        msg: apiMessage || "Fetched eSIM bookings successfully",
        data: { data: items, meta: { total } },
      };
    } else {
      result.msg =
        apiMessage ||
        res?.data?.error ||
        "Something went wrong fetching eSIM bookings!";
    }
  } catch (err) {
    result.msg = "Network Error!";
  }
  setLoading?.(false);
  return result;
}
